import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { APP_ROUTE_PATHS, buildCalculatorRoute } from "../appRoutePaths";
import { CALCULATOR_TOOLS } from "../data/calculatorCatalog";
import "./CommandBar.css";

const COMMAND_DESTINATIONS = [
  {
    id: "project-management-suite",
    name: "Project Management Suite",
    description: "Projects, plans, SOPs, files, inspection, tooling, machines, and shop workflow.",
    badge: "PM",
    route: APP_ROUTE_PATHS.projectManagement,
  },
  {
    id: "calculations-suite",
    name: "Calculations Suite",
    description: "Calculator search, pinned tools, recent tools, categories, formulas, and saved results.",
    badge: "CALC",
    route: APP_ROUTE_PATHS.calculationsSuite,
  },
  {
    id: "ai-assistant",
    name: "AI Manufacturing Assistant",
    description: "Manufacturing chat, SOP help, plan review, tooling, G-code, and setup-sheet support.",
    badge: "AI",
    route: APP_ROUTE_PATHS.aiAssistant,
  },
  {
    id: "manufacturing-plans",
    name: "Manufacturing Plans",
    description: "Business job and customer manufacturing plan workspace.",
    badge: "PLN",
    route: APP_ROUTE_PATHS.jobs,
  },
  {
    id: "personal-projects",
    name: "Personal Projects",
    description: "Personal saved workspaces for calculations, files, notes, and tasks.",
    badge: "PRJ",
    route: APP_ROUTE_PATHS.personalProjects,
  },
  {
    id: "formula-reference",
    name: "Formula Reference",
    description: "Manufacturing formula and shop math reference.",
    badge: "FR",
    route: APP_ROUTE_PATHS.formulaReference,
  },
  {
    id: "material-data",
    name: "Material Data",
    description: "Material properties and reference data.",
    badge: "MAT",
    route: APP_ROUTE_PATHS.materialData,
  },
];

const CommandBar = ({ open, setOpen }) => {
  const [query, setQuery] = useState("");
  const history = useHistory();

  if (!open) return null;

  const normalizedQuery = query.trim().toLowerCase();
  const commandItems = [
    ...COMMAND_DESTINATIONS.map((item) => ({ ...item, type: "route" })),
    ...CALCULATOR_TOOLS.map((tool) => ({
      ...tool,
      type: "calculator",
      route: buildCalculatorRoute(tool.id),
    })),
  ];

  const filtered = commandItems.filter((item) =>
    [item.name, item.description, item.badge, ...(item.categories || [])]
      .join(" ")
      .toLowerCase()
      .includes(normalizedQuery)
  );

  const handleSelect = (item) => {
    history.push(item.route);
    setOpen(false);
    setQuery("");
  };

  return (
    <div className="command-overlay" onClick={() => setOpen(false)}>
      <div className="command-bar" onClick={(event) => event.stopPropagation()}>
        <input
          autoFocus
          placeholder="Search projects, calculators, formulas, materials..."
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />

        <div className="command-results">
          {filtered.map((item) => (
            <div
              key={item.id}
              className="command-item"
              onClick={() => handleSelect(item)}
            >
              <span>{item.name}</span>
              <small>{item.badge}</small>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CommandBar;
